document.addEventListener("DOMContentLoaded", function () {
  const mainVideo = document.getElementById('product-video');
  const mainTimer = document.getElementById('video-timer');

  const modal = document.getElementById('video-modal'); // div container
  const modalVideo = modal.querySelector('video'); // the video inside modal
  const modalTimer = document.getElementById('modal-video-timer');
  const trigger = document.getElementById('video-overlay-trigger');
  const modalCloseBtn = document.getElementById('modal-close');

  const overlayText = trigger; // same element
  const videoControls = document.querySelector(".video-controls");

  if (!mainVideo || !mainTimer || !modal || !modalVideo || !modalTimer || !trigger || !modalCloseBtn || !overlayText || !videoControls) {
    console.warn("One or more required elements not found");
    return;
  }

  function formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }

  // Update main video timer
  mainVideo.addEventListener('timeupdate', () => {
    mainTimer.textContent = formatTime(mainVideo.currentTime);
  });

  // Update modal video timer
  modalVideo.addEventListener('timeupdate', () => {
    modalTimer.textContent = formatTime(modalVideo.currentTime);
  });

  // Open modal
  trigger.addEventListener('click', () => {
    modal.classList.add('active');

    // Hide main video & controls
    mainVideo.style.display = 'none';
    overlayText.style.display = 'none';
    videoControls.style.display = 'none';

    // Pause main video and reset time if you want
    mainVideo.pause();

    // Show and play modal video from start
    modalVideo.currentTime = 0;
    modalVideo.play();
  });

  // Close modal on close button click
  modalCloseBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    modal.classList.remove('active');

    // Show main video & controls again
    mainVideo.style.display = 'block';
    overlayText.style.display = 'block';
    videoControls.style.display = 'flex';

    // Pause modal video
    modalVideo.pause();

    // Resume main video if you want
    mainVideo.play();
  });

  // Close modal on clicking outside video or modal area
  modal.addEventListener('click', () => {
    modal.classList.remove('active');

    mainVideo.style.display = 'block';
    overlayText.style.display = 'block';
    videoControls.style.display = 'flex';

    modalVideo.pause();
    mainVideo.play();
  });

  modalVideo.addEventListener('click', e => {
    e.stopPropagation();
  });
});
